import React from 'react';
import { CtaLink } from './ui';
import { whatsappUrl } from '../../data/links';
export function SiteHeader() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-[#08090b]/90 backdrop-blur" data-id="element-79" data-mp="1ef0zxiw60h67">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-5 py-3.5 sm:px-8 lg:px-12" data-id="element-80" data-mp="1s5we9apfnqh6">
        <a href="#top" className="flex items-baseline gap-1.5" data-id="element-81" data-mp="1ncuxex5o1guy">
          <span className="font-display text-lg font-bold uppercase tracking-[0.18em] text-white sm:text-xl" data-id="element-82" data-mp="222ixxw60wbhm">
            VCARS
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-[#3b6bff]" data-id="element-83" data-mp="1x3xsnibwz1mb" />
        </a>

        <nav className="hidden items-center gap-7 text-sm text-white/60 md:flex" data-id="element-84" data-mp="2b2p40wze696r">
          <a href="#como-funciona" className="hover:text-white" data-id="element-85" data-mp="265yrgjmspvq3">
            Cómo funciona
          </a>
          <a href="#beneficios" className="hover:text-white" data-id="element-86" data-mp="gr0r10cq0gp0">
            Beneficios
          </a>
          <a href="#opciones" className="hover:text-white" data-id="element-87" data-mp="brxrfvfif2of">
            Opciones
          </a>
          <a href="#preguntas" className="hover:text-white" data-id="element-88" data-mp="2k6o5aqohfhzn">
            Preguntas
          </a>
        </nav>

        <CtaLink href={whatsappUrl('Hola VCARS, quiero que me asesoren para comprar un auto.')} label="WhatsApp" size="md" data-id="element-89" data-mp="2p5hmou6w3t53" />
      </div>
    </header>;
}